import { createReducer } from '../../../utils/state';
import { initialListState } from './list.state';
import {
    LIST_FETCHING_SET, LIST_FETCHING_MORE_SET, LIST_BULK_UPDATING_SET
} from '../../action-types';

export const listRequest = createReducer(initialListState, {
    /**
     * Sets the list fetch request status.
     * @param state
     * @param payload
     * @returns {{}}
     */
    [LIST_FETCHING_SET]: (state, { payload }) => {
        return { ...state, isFetching: payload };
    },

    [LIST_FETCHING_MORE_SET]: (state, { payload }) => {
        return { ...state, isFetchingMore: payload };
    },

    [LIST_BULK_UPDATING_SET]: (state, { payload }) => {
        return { ...state, isBulkUpdating: payload.isUpdating };
    }
});
